import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";

export class NgbCustomParserFormatter extends NgbDateParserFormatter {
  readonly DT_FORMAT = "MM/DD/YYYY";

  parse(value: string): NgbDateStruct {
    if (value) {
      value = value.trim();
      let mdt = moment(value, this.DT_FORMAT);
      return {
        year: parseInt(mdt.format("YYYY")),
        day: parseInt(mdt.format("D")),
        month: parseInt(mdt.format("M")),
      };
    }
    return null;
  }
  format(date: NgbDateStruct): string {
    if (!date) return "";
    let mdt = moment([date.year, date.month - 1, date.day]);
    if (!mdt.isValid()) return "";
    return mdt.format(this.DT_FORMAT);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/date-picker/ngb-custom-parser-formatter.ts